import { render, staticRenderFns } from "./VformDraggableDroppableMixin.js.vue?vue&type=template&id=a30136e2&"
import script from "./VformDraggableDroppableMixin.js.vue?vue&type=script&lang=js&"
export * from "./VformDraggableDroppableMixin.js.vue?vue&type=script&lang=js&"
import style0 from "./VformDraggableDroppableMixin.js.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports